<script lang="ts">
  let { ondone }: { ondone: () => void } = $props();
</script>

<div class="welcome">
  <h2>Where can I glide from here?</h2>
  <ol>
    <li><b>Find your launch.</b> Search for it, or pan the map and tap the spot.</li>
    <li><b>Set your glide ratio and wind</b> with the buttons below.</li>
    <li><b>Tap anywhere coloured</b> to see the route, your height there and the terrain profile.</li>
  </ol>
  <p class="warn">A planning aid, not a navigation instrument. It uses coarse terrain and an ideal glide, and ignores sink and turbulence.</p>
  <button class="btn primary" onclick={ondone}>Got it</button>
</div>

<style>
  .welcome h2 {
    margin: 2px 0 6px;
    font-size: 18px;
  }
  ol {
    margin: 0 0 8px;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 14px;
  }
  .warn {
    font-size: 12px;
    color: #92400e;
    background: #fef3c7;
    border-radius: 8px;
    padding: 6px 8px;
    margin: 0 0 8px;
  }
</style>
